module.exports = __webpack_public_path__ + "static/bank-476896ff48a098f77bb35925082e6b04.jpg";